import {
  FETCH_PUBLISHED_TEMPLATE_REQUEST,
  FETCH_PUBLISHED_TEMPLATE_SUCCESS,
  FETCH_PUBLISHED_TEMPLATE_FALUIRE,
} from './publishedTemplateListingTypes'

const initialState = {
  loading: false,
  publishedTemplateListingData: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_PUBLISHED_TEMPLATE_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_PUBLISHED_TEMPLATE_SUCCESS : return {
      ...state,
      publishedTemplateListingData: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_PUBLISHED_TEMPLATE_FALUIRE : return {
      ...state,
      loading: false,
      publishedTemplateListingData: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
